export const SUBSCRIPTION_CUSTOMER_GROUP_PREFIX = "subscription";

// Common data between braintree.Discount and giftup's GiftCardData
export type DiscountData = {
  code: string;
  amount: number;
  billingCycles?: number;
};

export enum DiscountError {
  NOT_FOUND,
  NOT_REDEEMABLE,
  MISMATCH, // Can't be applied to passed planID
  EXPIRED,
  EMPTY, // Backwards compatibility
}
